import {
  AUDIO_CDN_ORIGIN,
  AUTH_CDN_ORIGIN,
  CURATION_CDN_ORIGIN,
  LANDING_CDN_ORIGIN,
  NOTIFICATION_CDN_ORIGIN,
  PRICING_CDN_ORIGIN,
  ROADMAP_CDN_ORIGIN,
} from "./cdn";
export interface PageModuleStructure {
  origin: string;
  url: string;
  scope: string;
  module: string;
}
export type PageList =
  | "RoadmapBook"
  | "RoadmapCourse"
  | "RoadmapEntry"
  | "Notification"
  | "Landing"
  | "Curation"
  | "PremiumCourse"
  | "EssentialCourse"
  | "Audio"
  | "Pricing"
  | "PricingPlanParts"
  | "Auth";
export const pageSource: Record<PageList, PageModuleStructure> = {
  Notification: {
    origin: NOTIFICATION_CDN_ORIGIN,
    url: `${NOTIFICATION_CDN_ORIGIN}/_next/static/chunks/notification-bundle.js`,
    scope: "notification",
    module: "./App",
  },
  RoadmapBook: {
    origin: ROADMAP_CDN_ORIGIN,
    url: `${ROADMAP_CDN_ORIGIN}/_next/static/chunks/roadmap-bundle.js`,
    scope: "roadmap",
    module: "./Book",
  },
  RoadmapCourse: {
    origin: ROADMAP_CDN_ORIGIN,
    url: `${ROADMAP_CDN_ORIGIN}/_next/static/chunks/roadmap-bundle.js`,
    scope: "roadmap",
    module: "./Course",
  },
  RoadmapEntry: {
    origin: ROADMAP_CDN_ORIGIN,
    url: `${ROADMAP_CDN_ORIGIN}/_next/static/chunks/roadmap-bundle.js`,
    scope: "roadmap",
    module: "./Entry",
  },
  Landing: {
    origin: LANDING_CDN_ORIGIN,
    url: `${LANDING_CDN_ORIGIN}/static/js/landing-bundle.js?v=${Math.floor(
      new Date().getTime() / 1000
    )}`,
    scope: "landing",
    module: "./Landing",
  },
  Curation: {
    origin: CURATION_CDN_ORIGIN,
    url: `${CURATION_CDN_ORIGIN}/static/js/curation-bundle.js`,
    scope: "curation",
    module: "./Curation",
  },
  EssentialCourse: {
    origin: CURATION_CDN_ORIGIN,
    url: `${CURATION_CDN_ORIGIN}/static/js/curation-bundle.js`,
    scope: "curation",
    module: "./EssentialCourse",
  },
  PremiumCourse: {
    origin: CURATION_CDN_ORIGIN,
    url: `${CURATION_CDN_ORIGIN}/static/js/curation-bundle.js`,
    scope: "curation",
    module: "./PremiumCourse",
  },
  Audio: {
    origin: AUDIO_CDN_ORIGIN,
    url: `${AUDIO_CDN_ORIGIN}/_next/static/chunks/audio-bundle.js`,
    scope: "audio",
    module: "./Audio",
  },
  Pricing: {
    origin: PRICING_CDN_ORIGIN,
    url: `${PRICING_CDN_ORIGIN}/static/js/pricing-bundle.js`,
    scope: "pricing",
    module: "./Pricing",
  },
  PricingPlanParts: {
    origin: PRICING_CDN_ORIGIN,
    url: `${PRICING_CDN_ORIGIN}/static/js/pricing-bundle.js`,
    scope: "pricing",
    module: "./PricingPlanParts",
  },
  Auth: {
    origin: AUTH_CDN_ORIGIN,
    url: `${AUTH_CDN_ORIGIN}/static/js/auth-bundle.js`,
    scope: "auth",
    module: "./Auth",
  },
};
